const whatsappNumber = '85295946956';

export function createWhatsAppUrl(message: string) {
  return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
}

export const whatsappUrl = createWhatsAppUrl(
  '你好，我想查詢渡橋的服務及報價，請問可以提供更多資料嗎？',
);

export const whatsappUrlEn = createWhatsAppUrl(
  'Hello, I would like to enquire about Doq Creative services and pricing. Could you share more information?',
);
